import { render, staticRenderFns } from "./ReceptionDetailCommentsEditor.vue?vue&type=template&id=1ea11889&scoped=true&"
import script from "./ReceptionDetailCommentsEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailCommentsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailCommentsEditor.vue?vue&type=style&index=0&id=1ea11889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea11889",
  null
  
)

export default component.exports